import {EnvCountryModificationDomain} from "../../domain/env/EnvCountryModificationDomain"
import {EnvCountryId} from "../../id/env/EnvCountryId"
import {EnvCountryModificationId} from "../../id/env/EnvCountryModificationId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 국가 수정 이력
 */
export class EnvCountryModificationValueObject implements ValueObject, EnvCountryModificationDomain {
    /**
     * 기본키
     */
    id: EnvCountryModificationId
    /**
     * 수정자 ID
     */
    creatorId: UserId
    /**
     * 국가 ID
     */
    envCountryId: EnvCountryId
    /**
     * 이름
     */
    name: string
    /**
     * ISO 코드
     */
    isoCode: string
    /**
     * 전화번호 코드
     */
    phoneCode: number
    /**
     * 이모지
     */
    emoji: string
    /**
     * 수정일
     */
    createdAt: Date

    constructor(o: Record<keyof EnvCountryModificationDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.envCountryId = BigInt(o.envCountryId)
        this.name = String(o.name)
        this.isoCode = String(o.isoCode)
        this.phoneCode = Number(o.phoneCode)
        this.emoji = String(o.emoji)
        this.createdAt = new Date(o.createdAt)
    }
}
